import React, { useEffect, useState } from 'react';

const UseIsMobile = (breakpoint = 1024) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  const handleCheckSize = () => {
    if (window.innerWidth <= breakpoint) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleCheckSize);

    return () => {
      window.removeEventListener('resize', handleCheckSize);
    };
  }, []);

  return isMobile;
};

export default UseIsMobile;
